import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useStore, extractErrorMessage } from "../../../helpers";
import { markTarsNotebookActivity } from "./tars-notebook-last-touched";

export interface DeleteSourcePayload {
  source_id: number;
  notebook_id?: number;
}

export const useDeleteSource = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: DeleteSourcePayload): Promise<void> => {
      await rootStore.apiRequestHandler(
        "tars/source/delete",
        { source_id: payload.source_id },
        "Failed to delete source"
      );
    },
    onSuccess: (_data, variables) => {
      toast.success("Source deleted successfully");
      markTarsNotebookActivity(queryClient, variables.notebook_id);
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to delete source"));
    },
  });
};
